const initState = {
  unstakeAmount: 0,
  unstakeablePHNX: 0,
  availableAmount: 0,
  earlyUnstakeAmount: 0,
  stakes: [],
  phnxUsdValue: 0,
  onUnstakeConfirmationNumber: null,
};

const unstakeReducer = (state = initState, action) => {
  switch (action.type) {
    case "onUnStakeAmount":
      return {
        ...state,
        unstakeAmount: action.payload,
      };
    case "unstakeConfirmationNumber":
      return {
        ...state,
        onUnstakeConfirmationNumber: action.payload,
      };
    case "unstakeablePHNX":
      return {
        ...state,
        unstakeablePHNX: action.payload,
      };
    case "onSetPhnxUsdValue":
      return {
        ...state,
        phnxUsdValue: action.payload,
      };
    case "AVAIALBLE_AMOUNT":
      return {
        ...state,
        availableAmount: action.payload,
      };
    case "EARLY_UNSTAKE_AMOUNT":
      return {
        ...state,
        earlyUnstakeAmount: action.payload,
      };
    case "STAKES":
      return {
        ...state,
        stakes: action.payload,
      };
    case "LOGOUT_APP":
      return {
        initState,
      };
    default:
      return state;
  }
};

export default unstakeReducer;
